<template>
  <b-modal id="modal-dialog" ref="modal-dialog" size="xl" @hidden="clearModalData">
    <b-spinner v-if="formLoading" label="Items loading"></b-spinner>
      <b-table v-if="!formLoading && playlistUsage" :fields="fields" :items="playlistUsage" :busy="playlistUsage === null" :striped="true" :small="true" :responsive="true" :stacked="'sm'">
          <template #cell(type)="data">
            {{ data.item.type }}
          </template>
          
          <template #cell(name)="data">
            {{ data.item.name }}
          </template>

          <template #cell(id)="data">
            <b-button class="m-1" variant="primary" size="sm"
              @click.prevent="openItem(data.item)">Open</b-button>
          </template>
        </b-table>
    <!-- modal buttons -->
    <div slot="modal-footer" class="w-100">
      <b-button variant="light" class="float-right mx-2" @click="hideModal">Close</b-button>
    </div>
  </b-modal>
</template>

<script>
import playlistsMixin from '@/views/admin/playlists/playlistsMixin';


export default {
  mixins: [playlistsMixin],
  data() {
    return {
      formLoading: false,
      playlistId: null,
      playlistType: null,
      playlistUsage: null,
      fields: [
        { key: 'type', label: 'Type' },
        { key: 'name', label: 'Name' },
        { key: 'id', label: 'Options', tdClass: 'td-no-wrap' },
      ],
    };
  },
  created() {
    this.$root.$on('modal-show-playlist-usage', this.showModal);
  },
  beforeDestroy() {
    this.$root.$off('modal-show-playlist-usage', this.showModal);
  },
  methods: {
    showModal({
      playlistId,
      playlistType,
    }) {
      this.playlistId = playlistId;
      this.playlistType = playlistType;
      this.getPlaylistUsage(this.playlistId).then((data) => {
        this.playlistUsage = data;
      }).catch(() => {});
      this.$refs['modal-dialog'].show();
    },
    hideModal() {
      this.$refs['modal-dialog'].hide();
    },
    clearModalData() {
      this.playlistId = null;
      this.playlistType = null;
      this.playlistUsage = null;
    },
    openItem(item) {
      if(item.type === 'Device') {
        this.$router.push({ name: 'showDevice', params: { id: item.id } });
      }
      if(item.type === 'Group') {
        this.$router.push({ name: 'showGroup', params: { id: item.id } });
      }
    }
  },
};
</script>
